var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "jade-box",
    [
      _c("jade-group-header", { attrs: { title: _vm.$t("title") } }),
      _c("div", { staticClass: "flex flex-col gap-5 p-5" }, [
        _c(
          "div",
          { staticClass: "flex flex-col gap-1" },
          [
            _c(
              "jade-text",
              {
                attrs: {
                  variant: "text-medium",
                  weight: "semibold",
                  color: "high",
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("documents.name")) + " ")]
            ),
            _c("jade-text", { attrs: { color: "medium", weight: "medium" } }, [
              _vm._v(" " + _vm._s(_vm.$t("documents.example")) + " "),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "flex flex-col gap-1" },
          [
            _c(
              "jade-text",
              {
                attrs: {
                  variant: "text-medium",
                  weight: "semibold",
                  color: "high",
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("documents.format")) + " ")]
            ),
            _c("jade-text", { attrs: { color: "medium", weight: "medium" } }, [
              _vm._v(" " + _vm._s(_vm.$t("documents.format.sub")) + " "),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "flex flex-col gap-1" },
          [
            _c(
              "jade-text",
              {
                attrs: {
                  variant: "text-medium",
                  weight: "semibold",
                  color: "high",
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("documents.size")) + " ")]
            ),
            _c("jade-text", { attrs: { color: "medium", weight: "medium" } }, [
              _vm._v(" " + _vm._s(_vm.$t("documents.size.sub")) + " "),
            ]),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }